import { CSSProperties, RefObject, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { FixedSizeList as List } from 'react-window';
import styled from 'styled-components';

import { ArrowLeftSvg } from '../../../assets/icons';
import ArrowRightSvg from '../../../assets/icons/ArrowRightSvg';
import { useBreakPoint } from '../../../hooks/useBreakPoint';
import { useMarketingMetrics } from '../../../providers/PlausibleAnalyticsProvider';
import { Button } from '../../_atoms/Button';

const videoSrcs = [
  '/static/video1.MP4',
  '/static/video2.MP4',
  '/static/video3.MP4',
  '/static/video4.MP4',
  '/static/video5.mp4',
  '/static/video6.mp4',
  '/static/video7.mp4',
  '/static/video8.mp4',
  '/static/video9.mp4',
];

const VideoCarousel = () => {
  const { track } = useMarketingMetrics();
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const listRef = useRef<List>(null);

  const scrollToListItem = (index: number) => {
    if (listRef.current) {
      const itemOffset = index * 220;
      listRef.current.scrollTo(itemOffset);
    }
  };

  const goToPreviousVideo = () => {
    track('FrontPage.VideoCarousel.PreviousArrow');
    if (currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
      scrollToListItem(currentVideoIndex - 1);
    }
  };

  const goToNextVideo = () => {
    track('FrontPage.VideoCarousel.NextArrow');
    if (currentVideoIndex < videoSrcs.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
      scrollToListItem(currentVideoIndex + 1);
    }
  };

  return (
    <CarouselWrapper>
      <ArrowButton type="ghost" onClick={goToPreviousVideo}>
        <ArrowLeftSvg />
      </ArrowButton>
      <VideoList listRef={listRef} />
      <ArrowButton
        styles={{ left: 'unset', right: '0px' }}
        type="ghost"
        onClick={goToNextVideo}
      >
        <ArrowRightSvg />
      </ArrowButton>
    </CarouselWrapper>
  );
};

const Column = ({ index, style }: { index: number; style: CSSProperties }) => {
  const { track } = useMarketingMetrics();
  return (
    <div style={style}>
      <ReactPlayer
        onStart={() => track('FrontPage.VideoCarousel.VideoPlayed')}
        style={{ borderRadius: 10, overflow: 'hidden', margin: '0px 10px' }}
        controls
        url={videoSrcs[index]}
        height={350}
        width="fit-content"
      />
    </div>
  );
};

const VideoList = ({ listRef }: { listRef: RefObject<List> }) => {
  const isLargerThan500 = useBreakPoint(500);
  const isLargerThan850 = useBreakPoint(850);
  return (
    <List
      ref={listRef}
      height={350}
      itemCount={videoSrcs.length}
      itemSize={220}
      layout="horizontal"
      width={isLargerThan850 ? 660 : isLargerThan500 ? 440 : 220}
    >
      {Column}
    </List>
  );
};

const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 765px;
  position: relative;
  div {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
  margin: 0 auto;

  @media (max-width: 900px) {
    padding: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
    margin-right: 0px;
    width: 100%;
  }

  @media (max-width: 900px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

const ArrowButton = styled(Button)`
  position: absolute;
  top: 50%;
  left: 0px;
  border: none;
  padding: 0px;
  z-index: 2;
  svg {
    height: 30px;
    width: 30px;
    margin: 0px;
  }
`;

export default VideoCarousel;
